import { AppProtected } from '@/features/auth/app-protected';
import '@/index.css';
import { queryClient } from '@/shared/query-client';
import { router } from '@/shared/router';
import { loadConfig } from '@/utils/config';
import * as Sentry from '@sentry/react';
import { QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from '@tanstack/react-router';
import { createRoot } from 'react-dom/client';

const rootElement = document.getElementById('app')!;

async function initApp() {
  const sentryDsn = window.SENTRY_DSN;

  if (!import.meta.env.DEV && sentryDsn && sentryDsn.trim() !== '') {
    Sentry.init({
      dsn: sentryDsn,
      integrations: [
        Sentry.tanstackRouterBrowserTracingIntegration(router),
      ],
      sendDefaultPii: true,
      tracesSampleRate: 0,
    });
  }

  await loadConfig();

  if (!rootElement.innerHTML) {
    const root = createRoot(rootElement, {
      onUncaughtError: Sentry.reactErrorHandler(
        (error, errorInfo) => {
          console.warn(
            'Uncaught error',
            error,
            errorInfo.componentStack,
          );
        },
      ),
      onCaughtError: Sentry.reactErrorHandler(),
      onRecoverableError: Sentry.reactErrorHandler(),
    });

    root.render(
      <QueryClientProvider client={queryClient}>
        <AppProtected>
          <RouterProvider router={router} />
        </AppProtected>
      </QueryClientProvider>,
    );
  }
}

initApp().catch((error) => {
  console.error('Failed to initialize app', error);
});
